import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import {Link} from 'react-router'
import * as firebase from 'firebase'

const Jeyu = {
  photo: {
    width: 200,
    height: 200,
    boxShadow: '0 0 5px rgba(0,0,0,.3)',
    margin: 7
  },
  btn: {
    background: '#014852',
    color: '#fff',
    padding: '3px 15px',
    borderRadius: 7,
    border: '1px solid #014852',
    marginRight: 15,
    cursor: 'pointer'
  },
  flex: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100vh',
  },
  fromBox: {
    background: '#fff',
    width: 300,
    padding: '25px 20px',
    position: 'relative'
  },
  lightbox: {
    background: 'rgba(0,0,0,.8)',
    height: '100vh',
    position: 'fixed',
    width: '100%',
    zIndex: 9,
    left: 0,
    top: 0
  },
  UserProfile: {
    background: '#333',
    minHeight: '100vh',
    padding: '20px 10px'
  },
  Close: {
    position: 'absolute',
    left:0,
    top:'-22px',
    color: '#fff',
    cursor: 'pointer'
  },
  Remove: {
    background: '#333',
    color: '#fff',
    padding: '2px 8px 4px 11px',
    left: '-8px',
    top: '-6px',
    borderRadius: 60,
    fontSize: 12,
    position: 'absolute',
    opacity: '.4'
  },
  Edit: {
    background: '#333',
    color: '#fff',
    padding: '2px 8px 4px 11px',
    right: '-8px',
    top: '-6px',
    borderRadius: 60,
    fontSize: 12,
    position: 'absolute',
    opacity: '.4'
  },
  wordBox: {
    position: 'relative'
  }
}


export default class UserProfile extends Component {
  constructor() {
    super();
    this.state = {
      email: '',
      displayName: '',
      photoURL: '',
      title:'',
      valueEN: '',
      valueTW: '',
      circumscriptionEN: '',
      circumscriptionTW: '',
      exampleEN: '',
      exampleTW: '',
      tag: '',
      post: [],
      id: ''
    }
    this.addWord = this.addWord.bind(this)
    this.addWordSubmit = this.addWordSubmit.bind(this)
    this.handleChangeEN = this.handleChangeEN.bind(this)
    this.handleChangeTW = this.handleChangeTW.bind(this)
    this.handleChangeTag = this.handleChangeTag.bind(this)
    this.handleChangeCircumscriptionEN = this.handleChangeCircumscriptionEN.bind(this)
    this.handleChangeCircumscriptionTW = this.handleChangeCircumscriptionTW.bind(this)
    this.handleChangeExampleEN = this.handleChangeExampleEN.bind(this)
    this.handleChangeExampleTW = this.handleChangeExampleTW.bind(this)
    this.Remove = this.Remove.bind(this)
    this.CloseAdd = this.CloseAdd.bind(this)
    this.EditBox = this.EditBox.bind(this)
    this.editWordSubmit = this.editWordSubmit.bind(this)
    this.makeSure = this.makeSure.bind(this)
    this.Cancel = this.Cancel.bind(this)

  }

  addWord() {
    const checkLightBoxAddWord = ReactDOM.findDOMNode(this.refs.checkLightBoxAddWord)
    checkLightBoxAddWord.classList.add('isShow')
    this.setState({
      valueEN: '',
      valueTW: '',
      tag: '',
      circumscriptionEN: '',
      circumscriptionTW: '',
      exampleEN: '',
      exampleTW: ''
    })
  }
  CloseAdd() {
    const checkLightBoxAddWord = ReactDOM.findDOMNode(this.refs.checkLightBoxAddWord)
    const checkPostLightBoxAddWord = ReactDOM.findDOMNode(this.refs.checkPostLightBoxAddWord)
    checkLightBoxAddWord.classList.remove('isShow')
    checkPostLightBoxAddWord.classList.remove('isShow')
  }
  EditBox(postId) {
    const checkPostLightBoxAddWord = ReactDOM.findDOMNode(this.refs.checkPostLightBoxAddWord)
    checkPostLightBoxAddWord.classList.add('isShow')
    var userId = firebase.auth().currentUser.uid
    var editRef = firebase.database().ref('users/' + userId + '/post/').child(postId)
    editRef.on('value', snap => {
        this.setState({
          id: postId,
          valueEN: snap.val().valueEN,
          valueTW: snap.val().valueTW,
          tag: snap.val().tag,
          circumscriptionEN: snap.val().circumscriptionEN,
          circumscriptionTW: snap.val().circumscriptionTW,
          exampleEN: snap.val().exampleEN,
          exampleTW: snap.val().exampleTW
        })
    })
  }
  addWordSubmit(valueEN,valueTW,circumscriptionEN, circumscriptionTW, exampleEN, exampleTW) {
    var userId = firebase.auth().currentUser.uid
    var postListRef = firebase.database().ref('users/' + userId + '/post/')
    var newPostRef = postListRef.push()
    var postId = newPostRef.key

    // const newKey = firebase.database().ref('users/' + userId + '/post/').push().key
    newPostRef.set({
      id: postId,
      valueEN: this.state.valueEN,
      valueTW: this.state.valueTW,
      tag: this.state.tag,
      circumscriptionEN: this.state.circumscriptionEN,
      circumscriptionTW: this.state.circumscriptionTW,
      exampleEN: this.state.exampleEN,
      exampleTW: this.state.exampleTW
    })
    console.log(postId)
  }
  editWordSubmit(postId) {
    var userId = firebase.auth().currentUser.uid
    var editRef = firebase.database().ref('users/' + userId + '/post/').child(postId)
    editRef.update({
      id: postId,
      valueEN: this.state.valueEN,
      valueTW: this.state.valueTW,
      tag: this.state.tag,
      circumscriptionEN: this.state.circumscriptionEN,
      circumscriptionTW: this.state.circumscriptionTW,
      exampleEN: this.state.exampleEN,
      exampleTW: this.state.exampleTW
    })
    const checkPostLightBoxAddWord = ReactDOM.findDOMNode(this.refs.checkPostLightBoxAddWord)
    checkPostLightBoxAddWord.classList.remove('isShow')
  }
  Remove(postId) {
    const makeSureLightBox = ReactDOM.findDOMNode(this.refs.makeSureLightBox)
    makeSureLightBox.classList.add('isShow')
  }
  makeSure(postId) {
    var userId = firebase.auth().currentUser.uid
    var editRef = firebase.database().ref('users/' + userId + '/post/').child(postId)
    editRef.remove()
  }
  Cancel() {
    const makeSureLightBox = ReactDOM.findDOMNode(this.refs.makeSureLightBox)
    makeSureLightBox.classList.remove('isShow')
  }
  handleChangeEN(event) {
    this.setState({valueEN: event.target.value});
  }
  handleChangeTW(event) {
    this.setState({valueTW: event.target.value});
  }
  handleChangeTag(event) {
    this.setState({tag: event.target.value});
  }
  handleChangeCircumscriptionEN(event) {
    this.setState({circumscriptionEN: event.target.value});
  }
  handleChangeCircumscriptionTW(event) {
    this.setState({circumscriptionTW: event.target.value});
  }
  handleChangeExampleEN(event) {
    this.setState({exampleEN: event.target.value});
  }
  handleChangeExampleTW(event) {
    this.setState({exampleTW: event.target.value});
  }
  componentDidMount() {
    firebase.auth().onAuthStateChanged((user) => {
      const checkLogin = ReactDOM.findDOMNode(this.refs.checkLogin)
      if(user) {
        checkLogin.classList.add('isLogin')
        var userId = firebase.auth().currentUser.uid
        const rootRef = firebase.database().ref('users/').child(userId).child('UserProfile')
        rootRef.on('value', snap => {
          this.setState({
            email: snap.val().email,
            displayName: snap.val().displayName,
            photoURL: snap.val().photoURL
          })
        })

        const postRef = firebase.database().ref('users/' + userId + '/post/')
        postRef.on('value', snap => {
         // console.log(snap.val()) //上線需關閉

          snap.forEach((childSnap) => {
            this.setState({
                 post: this.state.post.concat(
                   [
                     {
                        id: childSnap.val().id,
                      valueEN: childSnap.val().valueEN,
                      valueTW: childSnap.val().valueTW,
                      tag: childSnap.val().tag,
                      circumscriptionEN: childSnap.val().circumscriptionEN,
                      circumscriptionTW: childSnap.val().circumscriptionTW,
                      exampleEN: childSnap.val().exampleEN,
                      example: childSnap.val().circumscriptionTW,
                     }
                   ]
                 ).reverse()
            })
          })
            // this.setState({
            //      post: this.state.post.concat(
            //        [
            //          {
            //             id: snap.val().id,
            //           valueEN: snap.val().valueEN,
            //           valueTW: snap.val().valueTW,
            //           tag: snap.val().tag,
            //           circumscriptionEN: snap.val().circumscriptionEN,
            //           circumscriptionTW: snap.val().circumscriptionTW
            //          }
            //        ]
            //      ).reverse()
            // })
        })
        postRef.on('child_removed', (snap) => {
          console.log('移除成功')
          window.location = ('/Removed')
        });
        postRef.on('child_changed', (snap) => {
          console.log('修改成功')
          window.location = ('/Removed')
        });

      } else {
        checkLogin.classList.remove('isLogin')
      }
    })
  }
  render() {
    const showPosts = this.state.post.map((post) => {
      return(
       <article key={post.id}>
        <div key={post.id} className="wordBox" style={Jeyu.wordBox}>
         <span onClick={() => this.Remove(post.id)} style={Jeyu.Remove}>X</span>
         <span onClick={() => this.EditBox(post.id)} style={Jeyu.Edit}>Edit</span>
         <h1>{ post.valueEN }</h1>
         <p>{ post.valueTW }</p>
         <sub>{ post.tag }</sub>
         <p>{ post.circumscriptionEN }</p>
         <p>{ post.circumscriptionTW }</p>
        </div>
        <div style={Jeyu.lightbox} className="postLightBox" ref="checkPostLightBoxAddWord">
         <form key={post.id} style={Jeyu.flex} onSubmit={() => this.editWordSubmit(post.id)}>
          <div style={Jeyu.fromBox}>
          <span onClick={this.CloseAdd} style={Jeyu.Close}>X</span>
           <div className="formGroup">
            <label htmlFor="wordEN">英文單字:</label>
            <input type="text" id="wordEN" required="true" value={this.state.valueEN} onChange={this.handleChangeEN} />
           </div>
           <div className="formGroup">
            <label htmlFor="wordTW">中文翻譯:</label>
            <input type="text" id="wordTW" required="true" value={this.state.valueTW} onChange={this.handleChangeTW} />
           </div>
           <div className="formGroup">
            <label htmlFor="wordTW">Tag:</label>
            <input type="text" id="wordTW" required="true" value={this.state.tag} onChange={this.handleChangeTag} />
           </div>
           <div className="formGroup">
            <label htmlFor="circumscriptionEN">定義英文:</label>
            <input type="text" id="circumscriptionEN" value={this.state.circumscriptionEN} onChange={this.handleChangeCircumscriptionEN} />
           </div>
           <div className="formGroup">
            <label htmlFor="circumscriptionTW">定義中文:</label>
            <input type="text" id="circumscriptionEN" value={this.state.circumscriptionTW} onChange={this.handleChangeCircumscriptionTW} />
           </div>
           <input type="submit" value="enter" style={Jeyu.btn} />
          </div>
         </form>
        </div>
        <div style={Jeyu.lightbox} className="makeSureBox" ref="makeSureLightBox">
         <form key={post.id} style={Jeyu.flex} onSubmit={() => this.editWordSubmit(post.id)}>
          <div style={Jeyu.fromBox}>
           <span style={Jeyu.btn} onClick={() => this.makeSure(post.id)}>確定刪除</span>
           <span style={Jeyu.btn} onClick={this.Cancel}>取消</span>
          </div>
         </form>
        </div>
        </article>
      )
    });
    return(
      <div className="container-fluid" style={Jeyu.UserProfile}>
       <div className="row">
       <div className="container" ref="checkLogin">
        <div className="row">
         <div className="lg-3">
          <img src={this.state.photoURL} alt="" style={Jeyu.photo}/>
         </div>
         <div className="lg-9">
          <p>{this.state.displayName}</p>
          <p>{this.state.email}</p>
          <Link to="/UserProfile" style={Jeyu.btn} onClick={this.addWord}>新增單字 / 詞彙</Link>
         </div>
           <div style={Jeyu.lightbox} className="wordLightBox" ref="checkLightBoxAddWord">
            <form style={Jeyu.flex} onSubmit={this.addWordSubmit}>
             <div style={Jeyu.fromBox}>
             <span onClick={this.CloseAdd} style={Jeyu.Close}>X</span>
              <div className="formGroup">
               <label htmlFor="wordEN">*英文單字:</label>
               <input type="text" id="wordEN" required="true" value={this.state.valueEN} onChange={this.handleChangeEN} />
              </div>
              <div className="formGroup">
               <label htmlFor="wordTW">*中文翻譯:</label>
               <input type="text" id="wordTW" required="true" value={this.state.valueTW} onChange={this.handleChangeTW} />
              </div>
              <div className="formGroup">
               <label htmlFor="tag">*Tag:</label>
               <input type="text" id="tag" required="true" value={this.state.tag} onChange={this.handleChangeTag} />
              </div>
              <div className="formGroup">
               <label htmlFor="circumscriptionEN">定義英文:</label>
               <textarea id="circumscriptionEN" value={this.state.circumscriptionEN} onChange={this.handleChangeCircumscriptionEN}></textarea>
              </div>
              <div className="formGroup">
               <label htmlFor="circumscriptionTW">定義中文:</label>
               <textarea id="circumscriptionEN" value={this.state.circumscriptionTW} onChange={this.handleChangeCircumscriptionTW}></textarea>
              </div>
              <input type="submit" value="enter" style={Jeyu.btn} />
             </div>
            </form>
           </div>
        </div>
        <div className="row">
         <div className="listBox md-12" ref="postList">
         <section className="panel-list">
          { showPosts }
         </section>
         </div>
        </div>
       </div>
       </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Component/UserProfile.js